import React from "react";
import { ShieldCheck, Wrench, Headphones } from "lucide-react";

export default function ServiceWarranty() {
  return (
    <section className="py-24 bg-white px-4">
      <div className="max-w-6xl mx-auto text-center">

        <h2 className="text-4xl sm:text-5xl font-bold mb-4">
          Service & Warranty You Can Trust
        </h2>

        <p className="text-gray-600 max-w-2xl mx-auto mb-14 leading-relaxed">
          Clean air is a long-term need.  
          AERZEN AIR™ is designed to serve your home reliably — with transparent warranty
          coverage and India-based support.
        </p>

        <div className="grid md:grid-cols-3 gap-10 text-left">

          {/* WARRANTY */}
          <div className="p-8 rounded-2xl border border-[var(--aerzen-silver)] shadow-sm">
            <ShieldCheck className="h-10 w-10 text-[var(--aerzen-blue)] mb-4" />
            <h3 className="font-semibold text-lg mb-2">
              2-Year Standard Warranty
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Covers manufacturing defects and electronic components under normal
              household usage.
              <br /><br />
              Consumables like HEPA filters are excluded, as per industry standards.
            </p>
          </div>

          {/* SERVICE */}
          <div className="p-8 rounded-2xl border border-[var(--aerzen-silver)] shadow-sm">
            <Wrench className="h-10 w-10 text-[var(--aerzen-blue)] mb-4" />
            <h3 className="font-semibold text-lg mb-2">
              Simple Service Process
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Support via phone or WhatsApp with guided troubleshooting.
              <br /><br />
              If required, repair or replacement is arranged through our authorised
              service network.
            </p>
          </div>

          {/* SUPPORT */}
          <div className="p-8 rounded-2xl border border-[var(--aerzen-silver)] shadow-sm">
            <Headphones className="h-10 w-10 text-[var(--aerzen-blue)] mb-4" />
            <h3 className="font-semibold text-lg mb-2">
              India-Based Customer Support
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Local support team familiar with Indian usage conditions —
              dust, pets, pollution spikes, and seasonal challenges.
              <br /><br />
              No offshore ticket loops or automated replies.
            </p>
          </div>
        </div>

        {/* FOOTNOTE */}
        <p className="text-xs text-gray-500 max-w-3xl mx-auto mt-12 leading-relaxed">
          Warranty terms apply as per product documentation.
          Coverage does not include damage due to misuse, electrical surges,
          or unauthorised modifications.
        </p>

      </div>
    </section>
  );
}
